export default "__VITE_ASSET__BtpvUdq9__"